// extracted by mini-css-extract-plugin
export var dark = "#262626";
export var gray = "#666";
export var light = "#eee";
export var primaryColor = "#ffd900";
export var primaryFont = "Inter";
export var secondaryFont = "Oswald";